export enum EFieldTooltipType {
    LIST = 'LIST',
    STRING = 'STRING',
    DYNAMIC_STRING = 'DYNAMIC_STRING',
    CURRENT_USER_INFO_LIST = 'CURRENT_USER_INFO_LIST',
}

export interface IFieldTooltipMetadata {
    width: string;
    type: EFieldTooltipType;
    requestUrl: string;
    contentEntityName: string;
    contentStructure: string;
}
